import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { PopVermasComponent } from './pop-vermas/pop-vermas.component';
import { FiltroBusquedaComponent } from './filtro-busqueda/filtro-busqueda.component';
import { PopAddGastoComponent } from './pop-add-gasto/pop-add-gasto.component';


@NgModule({
  declarations: [
    HeaderComponent,
    PopVermasComponent,
    FiltroBusquedaComponent,
    PopAddGastoComponent
  ],
  exports: [
    HeaderComponent,
    PopVermasComponent,
    FiltroBusquedaComponent,
    PopAddGastoComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
  ]
})
export class ComponentsModule { }
